export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["如果您忘记了账户访问密码，可以通过回答秘密问题来恢复。"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["在此部分，您可以更改秘密问题/答案。"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["秘密问题"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["您的问题："])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["答案："])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["保存"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["秘密问题"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["自定义问题"])}
}